import { GET_LEADS, GET_USED_BY_OPTIONS, GET_LEADS_AVAILABLE_COUNT, GET_LEADS_IDS_AVAILABLE, GET_LEAD_LISTS_NAMES, SAVE_LEADS_INTO_LIST, UPLOAD_LEADS, GET_LEADS_FROM_LIST, DELETE_LEADS } from "../constants";
import Requests from "../requests";

const LeadsService = {
    getLeads(page = 1, limit = 25, used_by = null, email = null, unassigned = false, hasEmail = false) {
        let url = `${GET_LEADS}?page=${page}&limit=${limit}`;
        if (used_by) {
            url += `&used_by=${used_by}`;
        }
        if (email) {
            url += `&email=${encodeURIComponent(email)}`;
        }
        if (unassigned) {
            url += `&unassigned=true`;
        }
        if (hasEmail) {
            url += `&has_email=true`;
        }
        return Requests.getWithAuth(url);
    },
    getUsedByOptions() {
        return Requests.getWithAuth(GET_USED_BY_OPTIONS);
    },
    getLeadListsNames() {
        return Requests.getWithAuth(GET_LEAD_LISTS_NAMES);
    },
    saveLeadsIntoList({leads_id, name}) {
        return Requests.postWithAuth(SAVE_LEADS_INTO_LIST, {leads_id, name});
    },
    getAllLeadsIdsAvailable() {
        return Requests.getWithAuth(GET_LEADS_IDS_AVAILABLE);
    },
    uploadLeadsUsingJSON(json) {
        return Requests.postWithAuth(UPLOAD_LEADS, json);
    },
    getLeadsFromList(name) {
        return Requests.getWithAuth(GET_LEADS_FROM_LIST.replace(':name', name));
    },
    getLeadsAvailableCount() {
        return Requests.postWithAuth(GET_LEADS_AVAILABLE_COUNT);
    },
    deleteLeads(leads_id) {
        return Requests.postWithAuth(DELETE_LEADS, { leads_id });
    }
}

export default LeadsService;